module.exports = __webpack_public_path__ + "img/warning.c26c9cfa.svg";